import { request } from '@/common/ajax/request';
import { Tc } from '@/providers/tc';

const VENDOR_LIST_URL = 'https://cdn.trustcommander.net/iab-v2/google-atp-list.json';
export class GoogleAcm extends Tc {
  constructor(categoryList, vendorsById) {
    super(categoryList, vendorsById);
    this.vendorList = {};
    for (const [vendorId, vendor] of Object.entries(this.vendorsById)) {
      const publicId = vendorId.split('_')[1];
      vendor.id = publicId;
    }
  }

  async initConsents(consentReducerFn = () => false) {
    await this.getVendorList();
    if (!this.vendorList) {
      return;
    }
    for (const vendor of Object.values(this.vendorsById)) {
      const acmVendor = this.vendorList.providers[vendor.id];
      if (acmVendor) {
        vendor.label = acmVendor.name;
        vendor.policyUrl = acmVendor.policyUrl;
        vendor.domains = acmVendor.domains;
      }
    }
    super.initConsents(consentReducerFn);
  }

  async getVendorList() {
    try {
      this.vendorList = await request.getJson(VENDOR_LIST_URL);

      return this.vendorList;
    } catch (e) {
      console.error('Google ACM Down', e);
    }
  }
}
